import { __decorate, __metadata } from "tslib";
import { Type } from '@ftr/serialization';
import { IsBoolean, ValidateIf } from 'class-validator';
import { Money } from '../order';
import { IsPositiveMoney } from '../order/validator';
/**
 * Enable/Disable and Configure the cost of paper copies for transcript orders
 */
export class PaperCopiesConfiguration {
    /**
     * @param enabled Whether paper copies will be an option on the transcript order form
     * @param paperCopyRate The cost of producing each paper copy per minute of audio to be transcribed
     */
    constructor(enabled, paperCopyRate) {
        this.enabled = enabled;
        this.paperCopyRate = paperCopyRate;
    }
}
__decorate([
    IsBoolean(),
    __metadata("design:type", Boolean)
], PaperCopiesConfiguration.prototype, "enabled", void 0);
__decorate([
    ValidateIf(c => c.enabled),
    IsPositiveMoney(),
    Type(() => Money),
    __metadata("design:type", Money
    /**
     * @param enabled Whether paper copies will be an option on the transcript order form
     * @param paperCopyRate The cost of producing each paper copy per minute of audio to be transcribed
     */
    )
], PaperCopiesConfiguration.prototype, "paperCopyRate", void 0);
export const DEFAULT_PAPER_COPIES_CONFIGURATION = { enabled: false };
